import { useAppSelector } from 'app/hooks';
import { selectSessionStatus } from 'app/selectors/selectSessionStatus';

import { SessionStatus } from 'model/types/session';

export default function useSession(): SessionStatus {
  return useAppSelector(selectSessionStatus);
}
